import React from 'react';
import { Trans } from '@lingui/macro';

function ContactUs() {
  return (
    <section className="section bg-light py-5" id="contact">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-12 mb-4 pb-2">
            <div className="section-title text-center">
              <h4 className="title mb-3"><Trans>CONTACT US</Trans></h4>
              <p className="para-desc mx-auto mb-2">
                <Trans>Have questions? Get in touch with us!</Trans>
              </p>
              <p className="para-desc mx-auto">
                <Trans>Email us directly at </Trans>
                <a href="mailto:info@amarefestival.com" className="text-primary">
                  info@amarefestival.com
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ContactUs;
